"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserTagsPaginatedType = exports.UserPaginatedType = exports.TokensType = exports.ServiceIdentitiesType = exports.TagMembersType = exports.GroupsType = exports.UsersType = exports.active = void 0;
var active = 'active';
exports.active = active;
var UsersType = {
  USERS_REQUEST: 'USERS_REQUEST',
  USERS_LOADING: 'USERS_LOADING',
  USERS_SUCCESS: 'USERS_SUCCESS',
  USERS_FAILURE: 'USERS_ERROR',
  USERS_RESET: 'USERS_RESET'
};
exports.UsersType = UsersType;
var GroupsType = {
  GROUPS_REQUEST: 'GROUPS_REQUEST',
  GROUPS_LOADING: 'GROUPS_LOADING',
  GROUPS_SUCCESS: 'GROUPS_SUCCESS',
  GROUPS_FAILURE: 'GROUPS_FAILURE',
  GROUPS_RESET: 'GROUPS_RESET'
};
exports.GroupsType = GroupsType;
var TagMembersType = {
  TAG_MEMBERS_REQUEST: 'TAG_MEMBERS_REQUEST',
  TAG_MEMBERS_LOADING: 'TAG_MEMBERS_LOADING',
  TAG_MEMBERS_SUCCESS: 'TAG_MEMBERS_SUCCESS',
  TAG_MEMBERS_FAILURE: 'TAG_MEMBERS_FAILURE',
  TAG_MEMBERS_RESET: 'TAG_MEMBERS_RESET',
  LOAD_MORE_TAG_MEMBERS_REQUEST: 'LOAD_MORE_TAG_MEMBERS_REQUEST'
};
exports.TagMembersType = TagMembersType;
var ServiceIdentitiesType = {
  SERVICE_IDENTITY_REQUEST: 'SERVICE_IDENTITY_REQUEST',
  SERVICE_IDENTITY_LOADING: 'SERVICE_IDENTITY_LOADING',
  SERVICE_IDENTITY_SUCCESS: 'SERVICE_IDENTITY_SUCCESS',
  SERVICE_IDENTITY_FAILURE: 'SERVICE_IDENTITY_FAILURE',
  SERVICE_IDENTITY_RESET: 'SERVICE_IDENTITY_RESET'
};
exports.ServiceIdentitiesType = ServiceIdentitiesType;
var TokensType = {
  TOKENS_REQUEST: 'TOKENS_REQUEST',
  TOKENS_LOADING: 'TOKENS_LOADING',
  TOKENS_SUCCESS: 'TOKENS_SUCCESS',
  TOKENS_FAILURE: 'TOKENS_FAILURE',
  TOKENS_RESET: 'TOKENS_RESET'
};
exports.TokensType = TokensType;
var UserPaginatedType = {
  USERS_REQUEST: 'USERS_PAGINATED_REQUEST',
  USERS_LOADING: 'USERS_PAGINATED_LOADING',
  USERS_SUCCESS: 'USERS_PAGINATED_SUCCESS',
  USERS_SUCCESS_LOAD_MORE: 'USERS_PAGINATED_LOAD_MORE_SUCCESS',
  USERS_FAILURE: 'USERS_PAGINATED_ERROR',
  USERS_RESET: 'USERS_PAGINATED_RESET'
};
exports.UserPaginatedType = UserPaginatedType;
var UserTagsPaginatedType = {
  USERS_TAGS_REQUEST: 'USERS_TAGS_PAGINATED_REQUEST',
  USERS_TAGS_LOADING: 'USERS_TAGS_PAGINATED_LOADING',
  USERS_TAGS_SUCCESS: 'USERS_TAGS_PAGINATED_SUCCESS',
  USERS_TAGS_SUCCESS_LOAD_MORE: 'USERS_TAGS_PAGINATED_LOAD_MORE_SUCCESS',
  USERS_TAGS_FAILURE: 'USERS_TAGS_PAGINATED_ERROR',
  USERS_TAGS_RESET: 'USERS_TAGS_PAGINATED_RESET'
};
exports.UserTagsPaginatedType = UserTagsPaginatedType;